/* eslint-disable */
export default {
  topic: 'Título de la reunión',
} as const;

// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
